import UploadIcon from '@eduzz/houston-icons/Upload';
import { Card, CardContent, CardHeader, Icon, IconButton, List, ListItem, ListItemSecondaryAction } from '@material-ui/core';
import ModalActions from 'components/ModalActions';
import Spin from 'components/Spin';
import React from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { upload } from 'store/Orbita/Upload/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  isModal: boolean;
  open: boolean;
  onClose: any;
  onOk: any;
  upload_id: any;
}

interface IStates {
  files: any;
  loading: boolean;
}

class File extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      files: [],
      loading: false,
    };
  }
  handleOk = () => {
    const { onOk } = this.props;
    const { files } = this.state;
    if (files && files.length) {
      if (onOk) {
        let newFile: any = {};
        newFile.method_id = '5';
        newFile.files = this.state.files;
        onOk(newFile);
        toast.success('Arquivo(s) adicionado(s) com sucesso!');
        this.setState({ files: [] });
      }
    } else {
      toast.warn('Por favor adicione pelo menos um arquivo');
    }
  };
  onDrop = (files: any) => {
    (async () => {
      try {
        for (let i = 0; i < files.length; i++) {
          this.setState({ loading: true });
          await this.props.dispatch(upload(files[i], 'entregar_arquivo'));
          let { upload_id } = this.props;
          if (upload_id) {
            files[i].upload_id = upload_id;
            files[i].new = true;
          }
        }
        this.setState({ files: this.state.files.concat(files), loading: false });
      } catch (error) {
        toast.error(error);
        this.setState({ loading: false });
      }
    })();
  };
  onRemoveItem = (index: number, item: any) => {
    let { files } = this.state;
    files.splice(index, 1);
    this.setState({ files });
    toast.success(`Arquivo ${item.name} removido com sucesso!`);
  };

  render() {
    const { isModal, open, onClose } = this.props;
    const { files, loading } = this.state;
    const content = (
      <div>
        {loading ? (
          <div>
            <Spin />
            <p>Por favor aguarde, estamos fazendo upload do(s) arquivo(s) ...</p>
          </div>
        ) : (
          <div>
            <Dropzone onDrop={this.onDrop}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div
                    style={{
                      padding: 24,
                      borderWidth: 2,
                      borderRadius: 2,
                      borderColor: '#eeeeee',
                      borderStyle: 'dashed',
                      backgroundColor: '#fafafa',
                      transition: 'border .3s ease-in-out',
                      height: '100%',
                      textAlign: 'center',
                      color: '#192542',
                      cursor: 'pointer',
                    }}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} id='input-product-delivery-files' />
                    <UploadIcon />
                    <p>Selecione ou arraste um ou mais arquivos aqui.</p>
                    <br />
                    <p style={{ fontSize: '0.9em', fontStyle: 'italic' }}>
                      Para PDFs, o DRM só será aplicado caso o documento não esteja bloqueado ou criptografado com senha
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
            <div className='m16' />
            <List>
              {files && files.length
                ? files.map((item: any, index: number) => (
                    <ListItem key={`file-${item.name}`}>
                      <p>{item.name}</p>
                      <ListItemSecondaryAction>
                        <IconButton onClick={() => this.onRemoveItem(index, item)}>
                          <Icon>clear</Icon>
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))
                : 'Nenhum arquivo adicionado.'}
            </List>
          </div>
        )}
      </div>
    );
    return (
      <div>
        {isModal ? (
          <ModalActions
            title={'Entrega de Conteúdo'}
            buttonOk='Salvar'
            open={open}
            onClose={onClose}
            onOk={this.handleOk}
            loading={this.state.loading}
          >
            {content}
          </ModalActions>
        ) : (
          <Card>
            <CardHeader
              title='Entrega de Conteúdo'
              action={
                <IconButton>
                  <Icon>clear</Icon>
                </IconButton>
              }
            />
            <CardContent>{content}</CardContent>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    upload_id: state.orbita.Upload.upload.upload_id,
  };
}

export default connect(mapStateToProps)(File);
